import {
  MatchCardShell,
  MatchStubBadge,
  MatchStubEventName,
  MatchStubFooter,
  MatchStubHeader,
} from './MatchStubShell'

type Props = {
  matchDate?: string
  eventName?: string
}

export function InformationalMatchStub({ matchDate, eventName }: Props) {
  return (
    <MatchCardShell>
      <MatchStubHeader>
        <MatchStubBadge label="INFORMATIONAL" variant="info" />
        <span />
      </MatchStubHeader>
      <MatchStubEventName name={eventName} />
      <MatchStubFooter matchDate={matchDate} />
    </MatchCardShell>
  )
}
